import { PropsWithChildren } from "react";
import { useSuspensionContext } from "../../context/suspension";
import OrganizationSuspended from "./index";

// Sits above DispensaryRoutes, so a suspended tenant never constructs a route
// element — no layout, no AuthGuard, no login form. Auth state is left
// untouched: lifting the suspension restores the session on the next load.
const SuspensionGate: React.FC<PropsWithChildren> = ({ children }) => {
    const { notice, isResolved } = useSuspensionContext();

    if (notice.isSuspended) return <OrganizationSuspended />;
    if (!isResolved) return null;

    return <>{children}</>;
};

export default SuspensionGate;
